import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export const ModalSendNotification = ({
  show,
  toggle,
  handleResumeMandate,
  isResuming,
  openDropdownId
}) => {
  const [resumption, setIsResumption] = useState("");
  const [target, setTarget] = useState("");

  const handleSend = () => {
    const payload = {
      date: resumption,
      target: target,
      openDropdownId: openDropdownId
    };

    handleResumeMandate(payload); // pass data up
  };

  return (
    <Modal show={show} onHide={toggle} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Send Notification</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>Are you sure you want to send notification?</p>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Date</Form.Label>
            <Form.Control
              type="date"
              value={resumption}
              onChange={(e) => setIsResumption(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Target</Form.Label>
            <Form.Select
              value={target}
              onChange={(e) => setTarget(e.target.value)}
            >
              <option value="">-- Select a Target --</option>
              <option value="agent">Agent</option>
              <option value="rsm">RSM</option>
              <option value="ssm">SSM</option>
              <option value="asm">ASM</option>
              <option value="customer">Customer</option>
              {/* Add more options as needed */}
            </Form.Select>
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button
          style={{
            fontSize: "0.8rem",
            fontWeight: 500,
            border: 0,
          }}
          onClick={handleSend}
          disabled={isResuming || !resumption || !target}
        >
          {isResuming ? "Sending, please wait.." : "Send"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
